/* jshint esversion: 6 */
import React, { useEffect, useState } from 'react';
import {
    useLocation,
    useNavigate,
    useParams,
    useMatches
} from 'react-router-dom';

export default function ComponentWithRouter(Component) {
    function ComponentWrapper(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        let matches = useMatches();
        let query = null;

        const [ lastLocation, setLastLocation ] = useState('');

        // the top and left nav are fixed and this being a SPA,
        // links don't reset the scroll, so the function below attempts to
        // correct that and roll up the screen when necessary
        useEffect(() => {
            let regex = new RegExp(/\/(\w+)/);

            // set the page title (defined in the handle object in Route)
            let match = matches[matches.length - 1];
            if (typeof match.handle === "function") {
                document.title = match.handle().title;
            }

            if (location.pathname !== lastLocation) {
                let lastParts = lastLocation.split("/"),
                    currentParts = location.pathname.split("/");

                if (lastParts[0] === '') {
                    lastParts.shift();
                }

                if (currentParts[0] === '') {
                    currentParts.shift();
                }

                if ((lastParts[0] !== currentParts[0] ||
                        lastParts[1] !== currentParts[1] ||
                        (!lastLocation.match("input") && location.pathname.match("input"))) &&
                        window.scrollY) {
                    window.scroll(0, 0);
                }
                setLastLocation(location.pathname);
            }

        }, [location.pathname]);

        if (location.search) {
            let searchParams = new URLSearchParams(location.search.substring(1));
            query = {};
            searchParams.forEach((value, key) => {
                query[key] = value;
            });
        }

        return (
            <Component
                {...props}
                router={{location, navigate, params, query}}/>
        );
    }


    return ComponentWrapper;
}
